import { Injectable } from '@angular/core';

export interface ISchedulingStatus {
    value: string,
    color: string
}


@Injectable()
export class SchedulingStatusService {
    private schedulingStatuses: Array<ISchedulingStatus> = [];

    constructor() {
        this.schedulingStatuses.push({ value: 'OnSchedule', color: '#0083A9' });
        this.schedulingStatuses.push({ value: 'WithDeviations', color: '#DC911B' });
        this.schedulingStatuses.push({ value: 'Delayed', color: '#AC0000' });
        this.schedulingStatuses.push({ value: 'FinishedWithDeviations', color: '#098809' });
        this.schedulingStatuses.push({ value: 'FinishedOnSchedule', color: '#098809' });
        this.schedulingStatuses.push({ value: 'UnknownStatus', color: 'transparent' });
        // Invoicing proposal only statuses
        this.schedulingStatuses.push({ value: 'AcceptedOnSchedule', color: '#098809' });
        this.schedulingStatuses.push({ value: 'AcceptedDelayed', color: '#098809' });
    }

    public getSchedulingStatusByValue(value: string): ISchedulingStatus {
        const selected = this.schedulingStatuses.filter(o => o.value === value);
        if (selected.length > 0) {
            return selected[0];
        } else {
            return this.schedulingStatuses[0];
        }
    }

    // Does not return invoicing proposal only statuses
    public getTaskSchedulingStatuses(): Array<ISchedulingStatus> {
        return this.schedulingStatuses.filter(o => 
            o.value !== 'AcceptedOnSchedule' && o.value !== 'AcceptedDelayed');
    }
}
